import { render, staticRenderFns } from "./Complaintsandsuggestions.vue?vue&type=template&id=33d6d59e"
import script from "./Complaintsandsuggestions.vue?vue&type=script&lang=js"
export * from "./Complaintsandsuggestions.vue?vue&type=script&lang=js"
import style0 from "./Complaintsandsuggestions.vue?vue&type=style&index=0&id=33d6d59e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports